import { render, staticRenderFns } from "./ControlPanelItem.vue?vue&type=template&id=2d40c1d8&scoped=true&"
import script from "./ControlPanelItem.vue?vue&type=script&lang=js&"
export * from "./ControlPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanelItem.vue?vue&type=style&index=0&id=2d40c1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40c1d8",
  null
  
)

export default component.exports